
import { Pipe, PipeTransform } from '@angular/core';
import { TypeOfPaymentsEnum } from '@core/enums/type-of-payments.enum';

/**
 * @description Retorna o nome do tipo de pagamento
 * */
@Pipe({name: 'typeOfPaymentsPipe'})
export class TypeOfPaymentsPipe implements PipeTransform {

  transform(value: string): string {
    return TypeOfPaymentsEnum[value];
  }
}
